const Islem = resolve => {
    require.ensure(['../views/apps/islem/Islem'], () => {
        resolve(require('../views/apps/islem/Islem'))
    })
};
const IslemDetay = resolve => {
    require.ensure(['../views/apps/islem/IslemDetay'], () => {
        resolve(require('../views/apps/islem/IslemDetay'))
    })
};

import Vue from 'vue'
Vue.component('IslemDetay', IslemDetay);
import layouts from '../layout'

export default {
    path: '/islem',
    name: 'islem',
    component: Islem,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'islemdetay',
            component: IslemDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
